import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAnimationOnScroll } from '../hooks/useAnimations';
import '../styles/pages/TeamApplication.scss';

const TeamApplication = () => {
    const { ref, inView } = useAnimationOnScroll({ threshold: 0.1 });
    const [showForm, setShowForm] = useState(false);
    const [formType, setFormType] = useState('team'); // 'team', 'community' veya 'kafes'
    
    // YouTube video ID'si
    const youtubeVideoId = "XfJU8fCtORo";

    // TODO: Buraya KAFES Başvuru Formu linkini ekleyin
    const kafesFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSeR77Vd5H3IOtE95iGvi-kEK3KZIYrDWuhDx8oMSvA7tWy-Iw/viewform?usp=header"; 

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getFormSrc = () => {
        switch(formType) {
            case 'team':
                return "https://docs.google.com/forms/d/e/1FAIpQLSfc1ojqPGIquy-ahSAkpw0e2bmQVYy2UOf1uDduz-AWTKdLkw/viewform?usp=header";
            case 'community':
                return "https://docs.google.com/forms/d/e/1FAIpQLSdZHmNnfefAiaus-j9lTa3TdPwePv8EAlP42bHRKR6Bf1Bovw/viewform?usp=header";
            case 'kafes':
                return kafesFormUrl; // KAFES linki
            default:
                return "";
        }
    };

    const getFormDescription = () => {
        switch(formType) {
            case 'team':
                return 'Black owLs ile profesyonel e-spor sahnesinde yerini almaya hazır mısın? Aşağıdaki formu doldurarak takım başvurunu yapabilirsin.';
            case 'community':
                return 'Black owLs topluluğuna katılarak etkinliklerimizden ve özel içeriklerimizden yararlanmak ister misin? Aşağıdaki formu doldurarak topluluk başvurunu yapabilirsin.';
            case 'kafes':
                return 'Kafes Yetkili Başvuru Formu\'nu doldurarak Kafes ekibine katılmak için ilk adımı atabilirsin.';
            default:
                return '';
        }
    };

    return (
        <div className="team-application-page gradient-bg min-h-screen py-16">
            <div className="section-container" ref={ref}>
                <div className="flex justify-between items-center mb-8">
                    <Link to="/" className={`inline-block text-owl-gold hover:underline ${inView ? 'fade-in' : ''}`}>
                        &larr; Ana Sayfaya Dön
                    </Link>
                    {showForm && (
                        <button
                            onClick={() => setShowForm(false)}
                            className="intro-button"
                        >
                            İntroyu Göster
                        </button>
                    )}
                </div>

                <h1 className={`section-title ${inView ? 'fade-in' : ''}`}>Black owLs Takımına Katıl</h1>
                
                <div className="team-logo-container mb-4 text-center">
                    <img src="/assets/images/owl_eye.jpg" alt="Black owLs Team Logo" className="team-logo mx-auto" style={{height: '150px', marginBottom: '20px'}} />
                </div>
                
                {!showForm ? (
                    <div className="intro-video-container fade-in">
                        <div className="intro-video youtube-container">
                            <iframe
                                className="youtube-embed"
                                width="100%"
                                height="450"
                                src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=0&rel=0&showinfo=0`}
                                title="Black owLs Tanıtım Videosu"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        
                        <div className="form-buttons-container">
                            {/* Üstteki İki Buton */}
                            <div className="buttons-row">
                                <button
                                    onClick={() => {
                                        setShowForm(true);
                                        setFormType('team');
                                    }}
                                    className="form-button team-button"
                                >
                                    Takım Başvuru Formu
                                </button>
                                <button
                                    onClick={() => {
                                        setShowForm(true);
                                        setFormType('community');
                                    }}
                                    className="form-button community-button"
                                >
                                    Topluluk Başvuru Formu
                                </button>
                            </div>
                            
                            {/* Alttaki Yeni Buton (KAFES) */}
                            <div className="buttons-row mt-4">
                                <button
                                    onClick={() => {
                                        setShowForm(true);
                                        setFormType('kafes');
                                    }}
                                    className="form-button community-button" // Topluluk stili ile aynı
                                >
                                    KAFES Başvuru Formu
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="google-form-container fade-in">
                        <div className="form-type-selector">
                            <button 
                                className={`form-type-button ${formType === 'team' ? 'active' : ''}`}
                                onClick={() => setFormType('team')}
                            >
                                Takım Başvurusu
                            </button>
                            <button 
                                className={`form-type-button ${formType === 'community' ? 'active' : ''}`}
                                onClick={() => setFormType('community')}
                            >
                                Topluluk Başvurusu
                            </button>
                            <button 
                                className={`form-type-button ${formType === 'kafes' ? 'active' : ''}`}
                                onClick={() => setFormType('kafes')}
                            >
                                KAFES Başvurusu
                            </button>
                        </div>
                        
                        <p className="text-center mb-6">
                            {getFormDescription()}
                        </p>
                        
                        <div className="google-form-wrapper">
                            <iframe 
                                src={getFormSrc()}
                                width="100%"
                                height="700" 
                                frameBorder="0" 
                                marginHeight="0" 
                                marginWidth="0">
                                Yükleniyor…
                            </iframe>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TeamApplication;